import { absoluteUrl, displayUrl } from '@datahub/shared'

/**
 * A web address the admin can click rather than copy out. What is shown is the tidy form
 * — `aruwacapital.com`, as the Stears platform renders it — while the link itself carries
 * the full address, so the two systems read the same and both still work.
 *
 * A value that is not a web address (a note, a half-typed domain) is left as plain text:
 * a link that goes nowhere is worse than no link.
 */
export function ExternalLink({ value, maxLength }: { value: unknown; maxLength?: number }) {
  const href = absoluteUrl(value)
  const label = displayUrl(value, maxLength)
  if (!href) return <>{label}</>

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={href}
      className="text-text-hyperlink hover:underline"
      style={{ wordBreak: 'break-word' }}
    >
      {label}
    </a>
  )
}
